import React from 'react'
import LoginForm from '../Components/LoginForm/LoginForm'
import Navbar2 from '../Components/Navbar/Navbar2'
import Footer from '../Components/Footer/Footer'


function LoginPage() {
  return (
    <div>
        <Navbar2/>
        <LoginForm/>
        <Footer/>
    </div>
  )
}

export default LoginPage